const GakHarusSulit: React.FC = () => {
    return (
        <div className="text-justify py-4">
            <h2 className="text-lg font-semibold mb-3">💡 Belajar Coding Itu Gak Harus Sulit!</h2>
            <p className="mb-4">
                Banyak yang mikir belajar ngoding itu ribet dan cuma buat orang jenius. Padahal kenyataannya enggak, kok! Dengan cara yang tepat, kamu bisa mulai belajar coding dengan mudah dan menyenangkan. Nih tipsnya:
            </p>

            <ul className="list-disc list-inside space-y-2 mb-4">
                <li>
                    <strong>Mulai dari proyek kecil 🧮</strong>
                    <p>Coba bikin kalkulator sederhana, to-do list, atau game tebak angka. Proyek kecil bantu kamu belajar tanpa stres!</p>
                </li>
                <li>
                    <strong>Gunakan bahasa yang mudah 🐍</strong>
                    <p>Python jadi favorit pemula karena sintaksnya simpel dan mudah dibaca. Kamu fokus ke logika, bukan ribet di aturan nulisnya.</p>
                </li>
                <li>
                    <strong>Tonton video interaktif 🎥 atau main game coding 🎮</strong> 
                    <p>Belajar gak harus lewat buku tebal. Ada banyak platform yang bikin belajar jadi seru dan gak ngebosenin.</p>
                </li>
                <li>
                    <strong>Konsisten lebih penting daripada cepat 🕒</strong>
                    <p>Belajar 30 menit tiap hari lebih baik daripada maraton 5 jam tapi cuma seminggu sekali. Coding itu seperti olahraga otak, harus rutin!</p>
                </li>
            </ul>

            <p className="text-gray-700">
                Jadi, buang jauh-jauh rasa takutmu. Semua programmer hebat dulunya juga pemula. Mulai aja dulu, pelan-pelan juga gak apa-apa. Yang penting: <strong>jangan berhenti belajar</strong> 🚀
            </p>
        </div>
    )
}
export default GakHarusSulit